module.exports = __webpack_public_path__ + "static/media/ic-telegram.67deb8f2.svg";